export const urls = {
  api: {
    internal: {
      userPreference: (uuid: string, key: string) =>
        `/!api/internal/user/preferences/${uuid}/${key}/`,
      userRepositoryPreference: (
        userUuid: string,
        repositoryUuid: string,
        key: string
      ) =>
        `/!api/internal/user/scoped-preferences/${userUuid}/repos/${repositoryUuid}/${key}/`,
      userWorkspacePreference: (
        userUuid: string,
        workspaceUuid: string,
        key: string
      ) =>
        `/!api/internal/user/scoped-preferences/${userUuid}/workspaces/${workspaceUuid}/${key}/`,
      repositoriesLanguages: (workspaceSlug: string) =>
        `/!api/internal/repositories/${workspaceSlug}/languages`,
    },
    v10: {},
    v20: {
      user: (uuid: string) => `/!api/2.0/users/${uuid}`,
    },
  },
  external: {},
  ui: {
    // Trailing slash is necessary here to avoid a redirect that could wipe out query params
    profile: (username: string) => `/${username}/workspace/overview/`,
  },
};
